// extracted by mini-css-extract-plugin
export default {"arrowSize":"8px","arrow":"FloatingArrow-module__arrow--xUlL8"};